import Marquee from "react-fast-marquee";

const phrases = ["Good Music", "Good People", "Good Vibes", "Eat. Sip. Vibe. Repeat"];

export const EditorialMarquee = () => (
  <section className="py-10 md:py-14 border-y border-white/10 bg-[#150505]/60" data-testid="marquee-section">
    <Marquee speed={40} gradient={false} autoFill>
      {phrases.map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif-display italic text-4xl md:text-6xl text-[#A19D94]/70 px-16 md:px-24 whitespace-nowrap">
            {p}
          </span>
          <span className="text-[#D4AF37] text-2xl md:text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
